import { z } from "zod";

/**
 * MotivoDemissaoSchema
 */

export const MotivoDemissaoSchema = z.object({
  ativo: z.coerce.number(),
  descricaoMotivo: z.string(),
});

/**
 * MotivoDemissaoForm
 */

export type MotivoDemissaoForm = z.infer<typeof MotivoDemissaoSchema>;

/**
 * Default value
 */

export const defaultMotivoDemissaoForm: MotivoDemissaoForm = {
  ativo: 1,
  descricaoMotivo: '',
}